export const initialState = {
  quizList: [],
  allquiz: [],
  quizContent: [],
  quizCategory:[]
};
